module.exports = __webpack_public_path__ + "img/RORBPJS40077.5ca9b3f4.png";